import { Card, CardText, CardBody, CardTitle, Container } from "reactstrap";
import './styles.scss';
import Spinner from "../Spinner";
import ScreenOverlay from "../ScreenOverlay";
import { Link } from "react-router-dom";

interface Props {
    title: string;
    totalCount?: number;
    totalCountDescr: string;
    recentCount?: number;
    recentCountDescr?: string;
    isLoading: boolean;
    buttonName: string;
    buttonLink: string;
    withoutRecent?: boolean;
}

const DashboardWidget = ({
    title,
    totalCount = 0,
    totalCountDescr,
    recentCount = 0,
    recentCountDescr,
    isLoading = false,
    buttonName,
    buttonLink,
    withoutRecent = false,
}: Props) => {
    return (
        <Card className="dashboard-widget">
            <CardBody>
                <CardTitle tag="h2" className="title text-black">{title}</CardTitle>
                <Container className="d-flex flex-column justify-content-center align-items-center w-100">
                    <div className="total-count">{isLoading ? '?' : totalCount}</div>
                    <CardText className="total-count-descr">{totalCountDescr}</CardText>
                    {!withoutRecent && (
                        <CardText className="recent-count-descr">
                            <span className="recent-count">{isLoading ? '?' : recentCount}</span> {recentCountDescr}
                        </CardText>
                    )}
                    <Link
                        className="details-button btn btn-outline-secondary w-100"
                        to={buttonLink}
                    >{buttonName}</Link>
                </Container>
                {isLoading && (
                    <>
                        <ScreenOverlay />
                        <Spinner />
                    </>
                )}
            </CardBody>
        </Card>
    );
};

export default DashboardWidget;
